/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  console.log("loaded starter kit JS");

  const selectors = {
    qtySelectorBtn: "button",
  };

  class QtySelectGrid extends HTMLElement {
    constructor() {
      super();
      this.qtySelectBtns = this.querySelectorAll(selectors.qtySelectorBtn);
      if (this.qtySelectBtns) {
        this.qtySelectBtns.forEach((btn) => {
          btn.addEventListener("click", this.toggleAriaSelected.bind(this));
          // Add event listener to handle clicks on inner elements
          btn.addEventListener("click", (event) => {
            // Check if the target is not the button itself
            if (event.target !== btn) {
              btn.click(); // Trigger the button's click event
            }
          });
        });
      }
    }

    toggleAriaSelected(event) {
      this.qtySelectBtns.forEach((btn) => {
        // const isSelected = event.target.getAttribute('aria-selected') === 'true';
        btn.setAttribute("aria-selected", "false");
      });
      event.target.setAttribute("aria-selected", "true"); // Set the clicked button as selected

      // Get the selected quantity from the custom attribute
      const selectedQuantity =
        parseInt(event.target.getAttribute("data-offer-qty"), 10) || 0;

      // Dispatch a custom event with the selected quantity
      this.dispatchEvent(
        new CustomEvent("quantity-selected", {
          detail: { selectedQuantity: selectedQuantity },
          bubbles: true, // Allow the event to bubble up the DOM
          composed: true, // Allow the event to cross the shadow DOM boundary
        })
      );
    }
  }

  // Check if the custom element is already defined before defining it
  if (!customElements.get("qty-select-grid")) {
    customElements.define("qty-select-grid", QtySelectGrid);
  }

  const selectors$2 = {
    offerContainer: ".offer-container",
    atcBtn: "[data-add-to-cart]",
    atcBtnText: ".btn__text",
  };

  class VariantQtySelect extends HTMLElement {
    constructor() {
      super();
     
      document.addEventListener("DOMContentLoaded", () => {
        this.atcBtn = document.querySelector(selectors$2.atcBtn);
        console.log('this.atcBtn');
        console.log(this.atcBtn);
        this.handleAddToCart();
      });
    }

    async handleAddToCart() {
      console.log('handling add to cart')

      const cartLinesInput = this.querySelector("input[name='items']");
      console.log('cartLinesInput')
      console.log(cartLinesInput)
      console.log('cartLinesInput value')
      console.log(cartLinesInput.value)

    
      // Initialize an array to hold the cart lines
      let cartLines = [];
    
      // Define the items to be added to the cart
      const bottleItem = {
        id: "41807002566793", 
        quantity: 1,
      };
    
      const ebookItem = {
        id: "43963811496073",
        quantity: 1,
      };
    
      const protectionItem = {
        id: "43033804308617",
        quantity: 1,
      };
    
      const sealItem = {
        id: "42429205250185",
        quantity: 2,
      };
    
      const chargingBlockItem = {
        id: "42880089227401", 
        quantity: 1,
      };
    
      // Add items to the cartLines array
      cartLines.push(bottleItem, ebookItem, protectionItem, sealItem, chargingBlockItem);
      console.log('cartLines')
      console.log(cartLines)

      cartLinesInput.value = JSON.stringify(cartLines);
      console.log('cartLinesInput updated')
      console.log(cartLinesInput)
      
    }
    
  }

  customElements.define("variant-qty-selector", VariantQtySelect);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
